import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { AlertService } from '@core/services/alert.service';
import { catchError, EMPTY, Observable, Subject, take, takeUntil, tap } from 'rxjs';

@Component({
	selector: 'sf-demo',
	styleUrls: ['./demo.component.scss'],
	template: `<div class="auth-container login">
		<div class="loader">
			<mat-spinner color="accent" [diameter]="80"></mat-spinner>
		</div>
	</div>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoComponent implements OnInit, OnDestroy {
	#destroy: Subject<void> = new Subject();

	constructor(
		private readonly authService: AuthService,
		private readonly alertService: AlertService,
		private readonly router: Router
	) {}

	public ngOnInit(): void {
		this.authService
			.login({ email: 'demo', password: 'demo' })
			.pipe(
				catchError(() => this.handleError()),
				tap(() => this.authService.navigateAfterLogin()),
				take(1),
				takeUntil(this.#destroy)
			)
			.subscribe();
	}

	public ngOnDestroy(): void {
		this.#destroy.next();
		this.#destroy.complete();
	}

	private handleError(): Observable<never> {
		this.alertService
			.openGlobalError()
			.afterClosed()
			.pipe(
				tap(() => this.router.navigate(['/'])),
				takeUntil(this.#destroy)
			)
			.subscribe();
		return EMPTY;
	}
}
